<div class="fx-bonus-history card bg-dark-lighter text-white">
  <div class="card-header ">
    {{ 'Promotion Code Control' | uppercase }}
  </div>
  <div class="card-body" id="manual_transaction">
    <div class="p-15">
      <div class="row mb-15">
        <div class="col-md-6 col-xs-12">
          <div
            class="input-group search-group" [ngClass]="{ loading: loading }">
            <input
              type="text"
              class="form-control bg-dark"
              name="keyword"
              [(ngModel)]="condition.keyword"
              placeholder="Search email"/>
            <div class="input-group-append">
              <button
                class="btn btn-main"
                type="button"
                (click)="searchHistory(true)"
              >
                Search
              </button>
              <button
                class="btn btn-main ml-2"
                type="button"
                (click)="onRefresh(true)"
              >
                Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <div class="table-responsive" #table>
            <form class="form" name="form">
              <table class="rox-table table-bordered bg-dark">
                <thead>
                  <tr>
                    <th class="text-center" rowspan="2">Campaign Name</th>
                    <th class="text-center" rowspan="2">Campaign Date</th>
                    <th class="text-center" rowspan="2">Bonus Method</th>
                    <th class="text-center" rowspan="2">Target Person</th>
                    <th class="text-center" colspan="2">Open Account Bonus </th>
                    <th class="text-center" rowspan="2">Upper Limit</th>
                    <th class="text-center mw-150" rowspan="2">Run Time</th>
                    <th class="text-center mw-150" rowspan="2">Bonus Timeout</th>
                    <th class="text-center mw-150" rowspan="2">Bonus Type</th>
                    <th class="text-center mw-150" rowspan="2">Status</th>
                    <th class="text-center mw-150" rowspan="2">Conditions</th>
                    <th class="text-center" rowspan="2">Code</th>
                  </tr>
                <tr>
                  <th class="text-center">USD</th>
                  <th class="text-center">JPY</th>
                </tr>
                </thead>
                <tbody>
                  <tr *ngFor="
                        let item of data
                          | paginate
                            : {
                                id: 'bonus_code_history',
                                itemsPerPage: pageInfo.pageSize,
                                currentPage: pageInfo.pageIndex,
                                totalItems: pageInfo.totalRecord
                              };
                        let i = index
                      ">
                    <td class="text-center position-relative text-long-wrapper" #promoName>
                      <div class="with-long"> <a href="javascript:void(0)" (click)="viewDetail(item.mt5_bonus_event_id,item.status)">{{item.name}}</a></div>
                      <div class="detail-tt" *ngIf="item.name.length > 29">{{item.name}}</div>
                    </td>
                    <td class="text-center">
                      <span>{{item.start_time | date: 'yyyy/MM/dd HH:mm'}}</span>
                      <span> - </span>
                      <span>{{item.end_time | date: 'yyyy/MM/dd HH:mm'}}</span>
                    </td>
                    <td class="text-center">
                      <span *ngIf="item.is_enable_account">Open Account</span>
                      <span *ngIf="item.is_enable_account && item.is_enable_deposit"> / </span>
                      <span *ngIf="item.is_enable_deposit">Deposit</span>
                    </td>
                    <td class="text-center">{{item.email}}</td>
                    <td class="text-center">
                      <div *ngIf="item.is_enable_account">
                        <span labelNumber="{{item.data.open_account.usd_bonus}}" [currency]="'usd'"></span>
                      </div>
                    </td>
                    <td class="text-center">
                      <div *ngIf="item.is_enable_account">
                        <span labelNumber="{{item.data.open_account.jpy_bonus}}" [currency]="'jpy'"></span>
                      </div>
                    </td>
                    <td class="text-center">
                      <div *ngIf="item.is_enable_deposit">
                        <span labelNumber="{{item.data.deposit.up_limit}}" [currency]="'jpy'"></span>
                      </div>
                    </td>

                    <td class="text-center mw-150">
                      <ng-container *ngIf="item.is_enable_deposit">{{item.data.deposit.conditions.length > 0 ? item.runTime : ''}}</ng-container>
                    </td>
                    <td class="text-center mw-150">
                      <ng-container *ngIf="item.is_enable_deposit">{{item.data.deposit.conditions.length > 0 ? (item.dfw + ' days') : ''}}</ng-container>
                    </td>
                    <td class="text-center mw-150">
                      <ng-container *ngIf="item.is_enable_deposit">{{item.data.deposit.conditions.length > 0 ? item.bonusType : ''}}</ng-container>
                    </td>
                    <td class="text-center mw-150">{{item.status}}</td>
                    <td class="text-start mw-150">
                      <ng-container *ngIf="item.is_enable_deposit">
                        <div class="fs-13 text-yellow"
                             *ngFor="let condition of item.data.deposit.conditions" style="white-space: nowrap">
                          <ng-container *ngIf="condition.rate || condition.threshold">
                            <span> ~ </span>
                            <span labelNumber="{{condition.threshold}}" [currency]="'jpy'"></span>
                            <span> | Bonus: </span>
                            <span labelNumber="{{(condition.rate * 100)}}" [currency]="'per'"></span>
                            %
                          </ng-container>
                        </div>
                      </ng-container>
                    </td>
                    <td class="text-center">
                      <div class="m-1">{{item.code}}</div>
                      <button class="btn btn-info rounded m-1" fx-copy="{{item.code}}">
                        {{'Copy' | translate}}
                      </button>
                    </td>
                    <!--<td class="text-center">
                      <a create-permission role="button"
                        class="text-red underline"
                        data-bs-toggle="modal"
                        (click)="selectedItem = item"
                        data-bs-target="#modalBonusNetwork"
                      >View</a
                      >
                    </td>-->
                  </tr>
                </tbody>
              </table>
            </form>
          </div>
        </div>
      </div>
      <div class="row mt-15">
        <div class="col">
          <div class="pagination-wrapper">
            <pagination-controls
              id="bonus_code_history"
              (pageChange)="pageChanged($event)"
              autoHide="true"
              responsive="true"
              previousLabel="Prev"
              nextLabel="Next"
            >
            </pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade fx-modal" id="modalBonusNetwork" *ngIf="selectedItem">
  <div
    class="modal-dialog modal-xl modal-fixed modal-dialog-centered modal-shadow"
  >
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h2 class="modal-title font-bold hidden"></h2>
        <button
          type="button"
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          &times;
        </button>
      </div>
      <!-- Modal body -->
      <div class="modal-body ">
        <div class="row">
          <div class="col-md-2 col-12">
            <div class="text-center">Name</div>
            <div class="text-center text-green">{{selectedItem.name}}  </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="text-center">Date</div>
            <div class="text-center text-green">
              {{selectedItem.start_time | date: 'yyyy/MM/dd'}}
               -
              {{selectedItem.end_time | date: 'yyyy/MM/dd'}}
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="text-center">Method</div>
            <div class="text-center text-green">
              <span *ngIf="selectedItem.is_enable_account">Open Account</span>
              <span *ngIf="selectedItem.is_enable_account && selectedItem.is_enable_deposit"> / </span>
              <span *ngIf="selectedItem.is_enable_deposit">Deposit</span>
            </div>
          </div>
          <div class="col-md-2 col-12">
            <div class="text-center">Target Person</div>
            <div class="text-center text-green fs-13">
              {{selectedItem.email}}
            </div>
          </div>
        </div>
        <hr />
        <div class="bonus-network">
          <div class="bonus-network__tree ">
            <fx-bonus-network
              [bonus]="selectedItem"
              (stateChanged)="expanded = false"
            ></fx-bonus-network>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
